/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 *
 * @export
 * @interface FacilityPhysician
 */
export interface FacilityPhysician {
    /**
     *
     * @type {string}
     * @memberof FacilityPhysician
     */
    id: string;
    /**
     *
     * @type {string}
     * @memberof FacilityPhysician
     */
    physician_name?: string | null;
    /**
     *
     * @type {string}
     * @memberof FacilityPhysician
     */
    physician_npi?: string | null;
    /**
     *
     * @type {boolean}
     * @memberof FacilityPhysician
     */
    is_default?: boolean;
    /**
     *
     * @type {string}
     * @memberof FacilityPhysician
     */
    facility_id?: string;
}

/**
 * Check if a given object implements the FacilityPhysician interface.
 */
export function instanceOfFacilityPhysician(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;

    return isInstance;
}

export function FacilityPhysicianFromJSON(json: any): FacilityPhysician {
    return FacilityPhysicianFromJSONTyped(json, false);
}

export function FacilityPhysicianFromJSONTyped(json: any, ignoreDiscriminator: boolean): FacilityPhysician {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'id': json['id'],
        'physician_name': !exists(json, 'physician_name') ? undefined : json['physician_name'],
        'physician_npi': !exists(json, 'physician_npi') ? undefined : json['physician_npi'],
        'is_default': !exists(json, 'is_default') ? undefined : json['is_default'],
        'facility_id': !exists(json, 'facility_id') ? undefined : json['facility_id'],
    };
}

export function FacilityPhysicianToJSON(value?: FacilityPhysician | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'id': value.id,
        'physician_name': value.physician_name,
        'physician_npi': value.physician_npi,
        'is_default': value.is_default,
        'facility_id': value.facility_id,
    };
}
